
import { Component, Mixins, Prop, Ref } from "vue-property-decorator";
import PageSection from "@/components/Common/PageSection.vue";
import VDataTable from "@monade/vue-components/src/components/VDataTable.vue";
import { User } from "../../models";
import ConfirmModal from "@/components/Common/VConfirmModal.vue";
import VPaginator from "@/components/Common/VPaginator.vue";
import UserMixin, { UserTags } from "@/mixins/http/UserMixin";
import { safeAsync } from "@/utils/AsyncUtil";
import { RegisterHttp } from "@/utils/Decorators";
import { currentUserStore, httpStore } from "@/store/typed";
import RequestData from "@/store/types/RequestData";
import EmptyView from "@/components/Common/EmptyView.vue";
import UserCreateModal from "@/components/User/Modal.vue";

import { showToast } from "@/utils/Toast";
const indexTag = UserTags.UserIndex;
const destroyTag = UserTags.UserDestroy;

@Component({
  components: {
    VDataTable,
    ConfirmModal,
    PageSection,
    VPaginator,
    EmptyView,
    UserCreateModal,
  },
})
export default class UserList extends Mixins(UserMixin) {
  @RegisterHttp(indexTag) readonly indexRequest!: RequestData;
  @RegisterHttp(destroyTag) readonly destroyRequest!: RequestData;
  @Ref() readonly confirmModal!: any;
  @Ref() readonly userCreateModal!: UserCreateModal;
  @Prop() readonly title!: string;
  @Prop() readonly backLink!: boolean;
  @Prop() readonly companyId!: string;
  @Prop() readonly organizationId!: string;
  @Prop() readonly withPadding!: boolean;
  @Prop() readonly filter!: any;

  private items: User[] = [];

  private error = false;

  private page = 1;

  get columns() {
    return [
      { name: "firstName", label: "Nome" },
      { name: "lastName", label: "Cognome" },
      { name: "email", label: "Email" },
      { name: "role", label: "Ruolo" },
      { name: "actions", label: "" },
    ];
  }

  get isMobile() {
    return this.$mq === "md" || this.$mq === "sm" || this.$mq === "xs";
  }

  get currentUser() {
    return currentUserStore.currentUser;
  }

  mounted() {
    this.load();
  }

  onPageChanged(page: number) {
    this.page = page;
    this.load();
  }

  destroyTag(id: string) {
    return `destroy_tag:${id}`;
  }

  get loading() {
    return this.indexRequest?.loading;
  }

  get meta() {
    return this.indexRequest?.meta;
  }

  private userFormattedRole(roleId: string) {
    return User.roles.find((el: any) => el.id === roleId).name;
  }

  onUpdated(user: User) {
    const index = this.items.findIndex((u: User) => u.id === user.id);
    this.$set(this.items, index, user);
  }

  itemLoading(id: string) {
    return httpStore.status[this.destroyTag(id)]?.loading;
  }

  edit(user: User) {
    (this.userCreateModal as any).edit(user);
  }

  add() {
    (this.userCreateModal as any).add();
  }

  async performDelete(id: string) {
    const [data, errors] = await safeAsync(this.destroyUser(id));

    if (!errors) {
      this.afterDelete(id);
    } else {
      showToast("Si è verificato un errore durante la cancellazione", {
        type: "error",
      });
    }
  }

  confirmDelete(id: string) {
    this.confirmModal.confirm(
      "Sei sicuro?",
      "Questa azione non è reversibile",
      id
    );
  }

  afterDelete(id: string) {
    this.items = this.items.filter((user: User) => user.id !== id);
  }

  get filterPayload() {
    return {
      page: this.page,
      filter: { maxRole: this.currentUser.role, ...this.filter },
    };
  }

  async load() {
    const [data, errors] = await safeAsync(this.getUsers(this.filterPayload));

    if (!errors) {
      this.items = data;
      this.error = false;
    } else {
      this.error = true;
    }
  }
}
